import clsx from 'clsx';

export function Button({ variant = 'default', size, className, children, ...rest }) {
  return (
    <button
      type="button"
      className={clsx('btn', variant !== 'default' && variant, size === 'sm' && 'sm', className)}
      {...rest}
    >
      {children}
    </button>
  );
}
